import { render, staticRenderFns } from "./ProductComboBox.vue?vue&type=template&id=50111ca7"
import script from "./ProductComboBox.vue?vue&type=script&lang=js"
export * from "./ProductComboBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports